/**
 * CU Home hero — pot entrance (elastic scale) + infinite float (yoyo yPercent).
 * GSAP comes from assets/cu-window.js via {% render 'cu-theme-global' %} in the theme layout.
 */
(function () {
  function loadGsap() {
    if (window.CU && typeof window.CU.loadGsap === 'function') {
      return window.CU.loadGsap();
    }
    if (window.gsap) {
      return Promise.resolve(window.gsap);
    }
    return Promise.reject(new Error('CU Home hero: add {% render "cu-theme-global" %} in theme.liquid (loads cu-window.js + GSAP).'));
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /**
   * @param {HTMLElement} root — element with [data-cu-home-hero-root]
   */
  function initCuHomeHero(root) {
    if (!root || root.dataset.cuHomeHeroReady === 'true') {
      return;
    }

    if (prefersReducedMotion()) {
      root.dataset.cuHomeHeroReady = 'true';
      return;
    }

    loadGsap()
      .then(function (gsap) {
        if (!root.isConnected) {
          return;
        }

        if (root._cuHomeHeroCtx) {
          root._cuHomeHeroCtx.revert();
          root._cuHomeHeroCtx = null;
        }

        var ctx = gsap.context(function () {
          var potDefaults = { transformOrigin: '50% 50%' };

          gsap
            .timeline({ defaults: potDefaults })
            .from('.home-hero_pot-wrapper.is-beauty', {
              scale: 0,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.home-hero_pot-wrapper.is-calming', {
              scale: 0,
              delay: -1.8,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.home-hero_pot-wrapper.is-immunity', {
              scale: 0,
              delay: -1.8,
              duration: 2,
              ease: 'elastic.out(0.9,0.4)',
            })
            .from('.home-hero_pot-wrapper.is-beauty', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -1.8,
              repeat: -1,
            })
            .from('.home-hero_pot-wrapper.is-calming', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -2.5,
              repeat: -1,
            })
            .from('.home-hero_pot-wrapper.is-immunity', {
              yPercent: 5,
              duration: 1.5,
              ease: 'power1.inOut',
              yoyo: true,
              delay: -1,
              repeat: -1,
            });
        }, root);

        root._cuHomeHeroCtx = ctx;
        root.dataset.cuHomeHeroReady = 'true';
      })
      .catch(function () {
        /* GSAP failed to load — leave pots static */
      });
  }

  function destroyCuHomeHero(root) {
    if (!root) {
      return;
    }
    if (root._cuHomeHeroCtx) {
      root._cuHomeHeroCtx.revert();
      root._cuHomeHeroCtx = null;
    }
    delete root.dataset.cuHomeHeroReady;
  }

  function scanAndInit(container) {
    var scope = container || document;
    var nodes = scope.querySelectorAll('[data-cu-home-hero-root]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-enable-pot-animation') !== 'false') {
        initCuHomeHero(nodes[i]);
      }
    }
  }

  function registerGlobalListenersOnce() {
    if (window.__cuHomeHeroListeners) {
      return;
    }
    window.__cuHomeHeroListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanAndInit();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scanAndInit(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-cu-home-hero-root]');
      for (var i = 0; i < roots.length; i++) {
        destroyCuHomeHero(roots[i]);
      }
    });
  }

  registerGlobalListenersOnce();
  scanAndInit();
})();
